import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';

import reducer from './reducer';
import sagas from './sagas';
import { authUpdate } from 'actions';

export function configureStore(browserHistory, authData, initialState) {
  const sagaMiddleware = createSagaMiddleware();

  const middleware = [
    routerMiddleware(browserHistory),
    sagaMiddleware
  ];

  let middlewareEnhancer = applyMiddleware(...middleware);

  if(process.env.NODE_ENV === 'development') {
    middlewareEnhancer = compose(
      applyMiddleware(...middleware),
      window.devToolsExtension ? window.devToolsExtension() : f => f
    );
  }

  const store = createStore(reducer, initialState, middlewareEnhancer);

  if(process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./reducer', () => {
      const nextReducer = require('./reducer').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  store.dispatch(authUpdate(authData));
  sagaMiddleware.run(sagas);

  return store;
}



/** WEBPACK FOOTER **
 ** ./src/members/state/store.js
 **/